import { AxiosError } from "axios";
import { useQuery } from "@tanstack/react-query";

import { KacApiCommonResponseDto } from "@shared/lib/types/api";
import { axiosInstance } from "@/config/axios";
import { useAccessToken } from "@/hooks/auth/use-access-token";
import { useCustomTranslation } from "@/utils/useCustomTranslation";

import { ScheduleResponseDto } from "@shared/generated/api/model";

export const useSchedule = (scheduleId: number) => {
  const { t } = useCustomTranslation();
  const { accessToken } = useAccessToken();

  return useQuery({
    queryKey: ["schedule", scheduleId],
    queryFn: async () => {
      try {
        const response = await axiosInstance.get(
          `/course/schedule/${scheduleId}`,
        );
        return response.data.body as ScheduleResponseDto;
      } catch (error) {
        const axiosError = error as AxiosError<KacApiCommonResponseDto<any>>;
        if (axiosError.response) {
          const errorMessage = axiosError.response.data?.error?.message;
          throw new Error(
            errorMessage || t("failed_to_load_schedule_information"),
          );
        }
        throw error;
      }
    },
    refetchInterval: 60 * 1000,
    staleTime: 0,
    retry: 3,
    enabled: !!accessToken,
  });
};
